import type { TranslationCatalog } from "../TranslationManager";

export const ms: TranslationCatalog = {
  "labels.cardNumber": "Nombor kad",
  "labels.expirationDate": "Tarikh luput",
  "labels.cvc": "Kod keselamatan",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "BB / TT",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Nombor kad anda tidak sah.",
  "errors.invalidExpiryDate": "Tarikh luput kad anda tidak sah.",
  "errors.invalidCvc": "Kod keselamatan kad anda tidak sah.",
  "errors.incompleteCardNumber": "Nombor kad anda tidak lengkap.",
  "errors.incompleteExpiryDate": "Tarikh luput kad anda tidak lengkap.",
  "errors.incompleteCvc": "Kod keselamatan kad anda tidak lengkap.",
  "errors.expiredCard": "Kad anda telah tamat tempoh.",
  "aria.cardNumber": "Nombor kad",
  "aria.expirationDate": "Tarikh luput",
  "aria.cvc": "Kod keselamatan",
  "aria.cardInput": "Maklumat kad",
};
